import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

import { Header, Main } from "../../components/page";
import { Button } from "../../components/button";
import { deleteBattleFromHistory } from "../../state/battle";
import { getScenario, getScoringPack } from "./battle-data";
import { BattleSetup } from "./BattleSetup";
import { BattleDashboard } from "./BattleDashboard";

import "./Battle.css";

const formatDate = (isoDate) => {
  try {
    return new Date(isoDate).toLocaleDateString();
  } catch {
    return "";
  }
};

export const Battle = () => {
  const dispatch = useDispatch();
  const battle = useSelector((state) => state.battle.active);
  const history = useSelector((state) => state.battle.history) || [];
  const [showSetup, setShowSetup] = useState(false);

  return (
    <>
      <Helmet>
        <title>Battle mode</title>
      </Helmet>

      <Header to="/" headline="Battle" />

      <Main className="battle">
        {battle ? (
          <BattleDashboard />
        ) : showSetup ? (
          <BattleSetup onDone={() => setShowSetup(false)} />
        ) : (
          <div className="battle__start">
            <Button
              type="primary"
              fullWidth
              spaceBottom
              onClick={() => setShowSetup(true)}
            >
              New battle
            </Button>

            {history.length > 0 && (
              <>
                <h2>Battle history</h2>
                <ul className="battle__history">
                  {history.map((finished) => {
                    const result = finished.result || {};
                    const pack = getScoringPack(finished.scoringPack);
                    const won = (result.playerVP || 0) >= (result.opponentVP || 0);

                    return (
                      <li key={finished.id} className="battle__history-item">
                        <div>
                          <b>
                            {won ? "Victory" : "Defeat"} vs{" "}
                            {finished.opponentName || "unknown"}
                          </b>
                          <small>
                            {formatDate(finished.finishedAt)} ·{" "}
                            {getScenario(finished.scenario)?.name || "—"} ·{" "}
                            {result.playerVP ?? 0}–{result.opponentVP ?? 0} VP
                            {pack?.brackets?.length > 0 &&
                              ` · ${result.playerBP ?? 0}–${
                                result.opponentBP ?? 0
                              } BP`}
                          </small>
                        </div>
                        <Button
                          type="text"
                          icon="delete"
                          label="Delete battle"
                          onClick={() =>
                            window.confirm("Delete this battle from history?") &&
                            dispatch(deleteBattleFromHistory(finished.id))
                          }
                        />
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </div>
        )}
      </Main>
    </>
  );
};
